/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface ModelGeneratorServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Start model generator
     * Start model generator to generate IFC models
     */
    startModelGenerator(extraHttpRequestParams?: any): Observable<string>;

}
